// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesStorageClassSettings
 */
export interface TypesStorageClassSettings {
  /**
   *
   * @type {string}
   * @memberof TypesStorageClassSettings
   */
  coreStorageClassIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof TypesStorageClassSettings
   */
  jobStorageClassIdentifier?: string;
}

/**
 * Check if a given object implements the TypesStorageClassSettings interface.
 */
export function instanceOfTypesStorageClassSettings(
  value: object,
): value is TypesStorageClassSettings {
  return true;
}

export function TypesStorageClassSettingsFromJSON(
  json: any,
): TypesStorageClassSettings {
  return TypesStorageClassSettingsFromJSONTyped(json, false);
}

export function TypesStorageClassSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesStorageClassSettings {
  if (json == null) {
    return json;
  }
  return {
    coreStorageClassIdentifier:
      json['CoreStorageClassIdentifier'] == null
        ? undefined
        : json['CoreStorageClassIdentifier'],
    jobStorageClassIdentifier:
      json['JobStorageClassIdentifier'] == null
        ? undefined
        : json['JobStorageClassIdentifier'],
  };
}

export function TypesStorageClassSettingsToJSON(
  json: any,
): TypesStorageClassSettings {
  return TypesStorageClassSettingsToJSONTyped(json, false);
}

export function TypesStorageClassSettingsToJSONTyped(
  value?: TypesStorageClassSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    CoreStorageClassIdentifier: value['coreStorageClassIdentifier'],
    JobStorageClassIdentifier: value['jobStorageClassIdentifier'],
  };
}
